import React, { useContext, useEffect, useState, useCallback } from 'react';
import { Loader, Toast } from '@getvim/atomic-ui';

import './App.less';
import { VimOSContext } from '../vimOsContext';
import { internalApi } from '../api';
import { useEnrichLoggerMetadata } from '../hooks/useEnrichLoggerMetadata';
import { createLogger } from '../utils/createLogger';

const logger = createLogger('App');

const initialState = {
  url: undefined,
  resultsError: false,
  isLoading: false,
};
const { ToastContainer, Slide } = Toast;

const App = () => {
  const { hub, sessionContext } = useContext(VimOSContext);
  const [shouldUpdateLaunchUrl, setShouldUpdateLaunchUrl] = useState<boolean>(true);

  const [launchUrl, setLaunchUrl] = useState<{
    url: string | undefined;
    resultsError: boolean;
    isLoading: boolean;
  }>(initialState);
  const { url, resultsError, isLoading } = launchUrl;

  const { user, organization, ehrType, sessionId } = sessionContext;
  useEnrichLoggerMetadata({ user, organization, ehrType, sessionId });

  const getWidgetLaunchUrl = useCallback(async () => {
    setShouldUpdateLaunchUrl(false);
    setLaunchUrl({
      url: undefined,
      isLoading: true,
      resultsError: false,
    });

    let launchUrl;
    try {
      const { idToken } = await sessionContext.getIdToken();
      internalApi.priviaApi.setAccessToken(idToken);
      launchUrl = await internalApi.priviaApi.getLaunchUrl();
    } catch (error) {
      logger.error('Failed to get Privia launch URL', {
        noPHI: true,
        launchUrl,
        error,
      });
    } finally {
      setLaunchUrl({
        url: launchUrl,
        isLoading: false,
        resultsError: !launchUrl,
      });
    }
  }, [sessionContext]);

  useEffect(() => {
    if (shouldUpdateLaunchUrl) {
      getWidgetLaunchUrl();
    }
  }, [shouldUpdateLaunchUrl, getWidgetLaunchUrl]);

  useEffect(() => {
    if (launchUrl.resultsError) {
      setLaunchUrl(initialState);
      setShouldUpdateLaunchUrl(true);
    }
  }, [launchUrl]);

  useEffect(() => {
    hub.setActivationStatus('ENABLED');
  }, [hub, hub.setActivationStatus]);

  return (
    <>
      <div className="privia-insights-app-container">
        <div className="frame-wrapper">
          {isLoading && <Loader type="dots" className="privia-insights-app-container__loader" />}
          {resultsError && <ErrorLoadIframe onRetry={getWidgetLaunchUrl} />}
          {url && <iframe title="privia-insights-widget" className="frame" src={url} />}
        </div>
      </div>
      <ToastContainer
        className=""
        position="bottom-right"
        hideProgressBar
        autoClose={3000}
        pauseOnFocusLoss={false}
        transition={Slide}
      />
    </>
  );
};

const ErrorLoadIframe: React.FC<any> = ({ onRetry }: any) => (
  <div className="error-load-iframe">
    <div className="error-load-iframe-title">Something went wrong :(</div>
    <div className="error-load-iframe-text">Please try again</div>
    <img
      className="error-load-iframe-img"
      src="https://static.getvim.com/img/errorPageImg.png"
      alt="loading logo"
    />
    <button type="button" className="error-load-iframe-button" onClick={onRetry}>
      Retry
    </button>
  </div>
);

export default App;
